(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

  const SECTION_ID = ("" + __shopifySectionId + "");
  const ROOT_ID = 'YurchakCart-' + SECTION_ID;
  const routeRoot = () => window.Shopify?.routes?.root || (window.Shopify?.routes?.root || '/');
  const setCount = cart => {
    const isExpressItem = item => window.YurchakCartCore?.isExpress
      ? window.YurchakCartCore.isExpress(item)
      : String(item?.handle || item?.product_handle || '').toLowerCase() === 'express-delivery-upgrade' ||
        String(item?.properties?._yurchak_express_delivery || '').toLowerCase() === 'true';
    const count = Array.isArray(cart?.items)
      ? cart.items.reduce((sum,item) => isExpressItem(item) ? sum : sum + Number(item?.quantity || 0), 0)
      : Number(cart?.item_count || 0);
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"],.cart-count-bubble span:first-child').forEach(node => node.textContent = count);
    document.querySelectorAll('.cart-count-bubble').forEach(node => node.classList.toggle('hidden',count === 0));
  };
  const paintPerks = root => {
    const core = window.YurchakCartCore;
    if (!root || !core?.thresholdCents || !core?.shippingThresholdCents || !core?.format) return;

    const total = Math.max(0,Number(root.dataset.merchandiseTotal || 0));
    const giftUsd = Number(root.dataset.giftUsd || 120);
    const shippingUsd = Number(root.dataset.shippingUsd || 160);
    const currency = String(root.dataset.currency || 'USD').toUpperCase();
    const country = String(root.dataset.country || '').toUpperCase();
    const hasGift = root.dataset.hasGift === 'true';
    const gift = core.thresholdCents(giftUsd,currency);
    const shipping = core.shippingThresholdCents(shippingUsd,currency,country);
    const visualShipping = shipping > 0 ? shipping : core.thresholdCents(shippingUsd,currency);

    let giftPosition = 100;
    let pct = 0;
    if (gift > 0 && visualShipping > gift) {
      giftPosition = 64;
      if (total < gift) {
        pct = Math.max(0,Math.min(64,(total / gift) * 64));
      } else {
        pct = Math.max(64,Math.min(100,64 + ((total - gift) / (visualShipping - gift)) * 36));
      }
    } else if (gift > 0) {
      pct = Math.max(0,Math.min(100,(total / gift) * 100));
    }

    const perks = root.querySelector('[data-ycart-perks]');
    if (!perks) return;
    perks.classList.toggle('ycart__perks--free-shipping',shipping <= 0);
    perks.classList.toggle('is-gift-unlocked',total >= gift);
    perks.classList.toggle('is-shipping-unlocked',shipping > 0 && total >= shipping);
    perks.style.setProperty('--ycart-gift-position',giftPosition + '%');

    const track = perks.querySelector('[role="progressbar"]');
    const fill = perks.querySelector('[data-ycart-perk-fill]');
    if (track) track.setAttribute('aria-valuenow',String(Math.round(pct)));
    if (fill) fill.style.width = pct + '%';

    const giftLabel = perks.querySelector('[data-ycart-gift-label]');
    const shippingLabel = perks.querySelector('[data-ycart-shipping-threshold-label]');
    if (giftLabel) giftLabel.textContent = core.format(gift,currency) + ' · FREE GIFT';
    if (shippingLabel) {
      shippingLabel.hidden = shipping <= 0;
      shippingLabel.textContent = shipping > 0 ? core.format(shipping,currency) + ' · FREE SHIPPING' : '';
    }

    const title = perks.querySelector('[data-ycart-perk-title]');
    if (title) {
      if (shipping <= 0) {
        title.textContent = total >= gift
          ? 'Gift unlocked · Free shipping included'
          : core.format(Math.max(0,gift-total),currency) + ' to your gift · Free shipping included';
      } else if (total >= shipping) {
        title.textContent = 'Gift + free shipping unlocked';
      } else if (total >= gift) {
        title.textContent = 'Gift unlocked · ' + core.format(Math.max(0,shipping-total),currency) + ' to free shipping';
      } else {
        title.textContent = core.format(Math.max(0,gift-total),currency) + ' to your gift';
      }
    }

    const shippingStatus = root.querySelector('[data-ycart-shipping-label]');
    if (shippingStatus) {
      shippingStatus.textContent = shipping <= 0 || total >= shipping ? 'Free shipping unlocked' : 'Calculated at checkout';
    }

    const giftButton = root.querySelector('[data-ycart-gift-button]');
    if (giftButton && (total < gift || hasGift)) giftButton.classList.add('is-hidden');
  };
  const changeCart = async (key,quantity) => {
    const safeQuantity = Math.max(0,Number(quantity || 0));
    if (window.YurchakCartCore?.changeLine) {
      return window.YurchakCartCore.changeLine(key,safeQuantity);
    }
    const response = await fetch(routeRoot() + 'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:key,quantity:safeQuantity})});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed.');
    return data;
  };
  const refreshMarkup = async cart => {
    const current = document.getElementById(ROOT_ID);
    if (!current) return;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id',SECTION_ID);
    url.hash = '';
    const response = await fetch(url.toString(),{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
    if (!response.ok) throw new Error('Could not refresh cart layout.');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html,'text/html');
    const fresh = doc.getElementById(ROOT_ID);
    if (!fresh) throw new Error('Cart layout was not returned.');
    current.replaceWith(fresh);
    setCount(cart);
    window.YurchakCartSectionInit?.();
    window.YurchakCartCore?.emit?.(cart,'yurchak-cart-page','cart-updated');
  };
  window.YurchakCartSectionInit = () => {
    const root = document.getElementById(ROOT_ID);
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    paintPerks(root);
    let busy = false;
    const lock = value => { busy = value; root.classList.toggle('is-loading',value); };
    const change = async (row,quantity) => {
      if (busy || !row) return;
      lock(true);
      try { const cart = await changeCart(row.dataset.key,quantity); await refreshMarkup(cart); }
      catch (error) { console.error(error); lock(false); }
    };
    root.querySelectorAll('[data-ycart-item]').forEach(row => {
      const input = row.querySelector('[data-ycart-qty]');
      row.querySelector('[data-ycart-minus]')?.addEventListener('click',() => { const next = Math.max(0,Number(input?.value || 0)-1); if (input) input.value = next; change(row,next); });
      row.querySelector('[data-ycart-plus]')?.addEventListener('click',() => { const next = Number(input?.value || 0)+1; if (input) input.value = next; change(row,next); });
      input?.addEventListener('change',() => change(row,input.value));
      row.querySelector('[data-ycart-remove]')?.addEventListener('click',() => change(row,0));
    });
  };
  window.YurchakCartSectionInit();
})();
